import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { Row, Col, NavItem } from "reactstrap";
import { utils } from "../../core/helpers/utils";
import {
  setAnalyticsEvent,
  setCleverTapEvent,
} from "../../core/helpers/analytics";


class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      headerRendring: false,
    };
  }

  callShare = () => {
    {
      process.env.REACT_APP_RENDER_GA === "true" &&
      setAnalyticsEvent("/shareClick", "Post-Login-Share-Click");
    }
    setCleverTapEvent("Share Button Click");
    utils.amazonShare();
  };

  checkIsAltAsset = (tab) => {
    if (tab === "alt") {
      this.setState({ altIsActive: true });
    } else {
      this.setState({ altIsActive: false });
    }
    this.props.onUserProfileCloseClicked();
  };

  componentDidMount() {
    if (window.location.hash === "#/alternate-assets") {
      this.checkIsAltAsset("alt");
    }
    switch (window.location.href.split('#')[1]) {
      case "/" : 
        this.setState({
          activetab: 'bonds'
        })
        break;

      case "/biddeasy-dashboard" : 
        this.setState({
          activetab: 'bonds'
        })
        break;

      case "/portfolio" : 
        this.setState({
          activetab: 'portfolio'
        })
        break;

      default :
        this.setState({
          activetab: ''
        })
    }
  }

  setActiveTab(tab) {
    this.setState({
      activetab: tab
    })
  }

  openFdLink = (tab) =>{
    this.setState({
      activetab: tab
    }, () => {
      window.open(process.env.REACT_APP_BASE_URL_FD, '_self')
    })
  }

  handleHomeClick(tab) {
    if (tab === "home") {
      if (this.props.userType === "fd") {
        window.open(process.env.REACT_APP_BASE_URL_FD, '_self')
      } else {
        window.open(process.env.REACT_APP_NEUTRAL_POST_URL, '_self')
      }
    }
    this.setState({
      activetab: tab
    })
  }

  handleMoreClick(tab) {
    if (!this.props.isProfileDrawerOpen) {
      this.props.onUserProfileClicked();
    }
    if (this.props.isProfileDrawerOpen) {
      this.props.onUserProfileCloseClicked();
    }
    this.setState({
      activetab: tab
    })
  }


  render() {
    return (
      <div className="mobile-menu d-lg-none d-xl-none d-block bg-light">
        <Row className=" ml-auto mr-auto">
          <Col className="text-center d-flex align-items-center justify-content-center col-3">
            <NavLink
              exact
              activeClassName="active"
              to="/"
              className="text-uppercase font-size-tiny font-weight-semi-bold"
              onClick={this.props.handleLogoClick}
            >
              <svg className="mb-2" width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.5 8.5L11.5 1.5L21.5 8.5V19.5C21.5 20.0304 21.2659 20.5391 20.8491 20.9142C20.4324 21.2893 19.8671 21.5 19.2778 21.5H3.72222C3.13285 21.5 2.56762 21.2893 2.15087 20.9142C1.73413 20.5391 1.5 20.0304 1.5 19.5V8.5Z" stroke={this.state.activetab === "home" ? "#283A97" : "#898A8D"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span style={this.state.activetab === 'home' ? {color: "#283A97", marginTop: "10px"} : {color: "#898A8D", marginTop: "10px"}}><br/>Home</span>
            </NavLink>
          </Col>
          {/* <Col className="text-center d-flex align-items-center justify-content-center col-3">
            <div
              className="text-uppercase font-size-tiny font-weight-semi-bold"
              onClick={() => this.openFdLink("fd")}
            >
              <svg className="mb-2" width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M2.37234 0.5C1.33828 0.5 0.5 1.33828 0.5 2.37234V6.35106H2.37234V2.37234H19.2234V17.3511C19.2234 18.3851 18.3851 19.2234 17.3511 19.2234H4.24468C3.21062 19.2234 2.37234 18.3851 2.37234 17.3511V11.266H0.5V17.3511C0.5 19.4192 2.17655 21.0957 4.24468 21.0957H4.24669C4.24536 21.1168 4.24468 21.1381 4.24468 21.1596V21.5C4.24468 22.0523 4.6924 22.5 5.24468 22.5H6.52128C7.07356 22.5 7.52128 22.0523 7.52128 21.5V21.1596C7.52128 21.1381 7.5206 21.1168 7.51927 21.0957H14.5446C14.5432 21.1168 14.5426 21.1381 14.5426 21.1596V21.5C14.5426 22.0523 14.9903 22.5 15.5426 22.5H16.8191C17.3714 22.5 17.8191 22.0523 17.8191 21.5V21.1596C17.8191 21.1285 17.8177 21.0977 17.8149 21.0673C19.6642 20.8388 21.0957 19.2621 21.0957 17.3511V2.37234C21.0957 1.33828 20.2575 0.5 19.2234 0.5H2.37234ZM13.8395 8.92541C14.4858 8.92541 15.0097 8.40149 15.0097 7.75519C15.0097 7.1089 14.4858 6.58498 13.8395 6.58498C13.1932 6.58498 12.6693 7.1089 12.6693 7.75519C12.6693 8.40149 13.1932 8.92541 13.8395 8.92541ZM16.882 7.75519C16.882 9.02087 16.1092 10.106 15.0097 10.5646V13.2942C15.0097 13.7251 14.5905 14.0743 14.0735 14.0743C13.5565 14.0743 13.1373 13.7251 13.1373 13.2942V10.7163C11.7955 10.3994 10.7969 9.19389 10.7969 7.75519C10.7969 6.07484 12.1591 4.71264 13.8395 4.71264C15.5198 4.71264 16.882 6.07484 16.882 7.75519Z" fill={this.state.activetab === "fd" ? "#283A97" : "#898A8D"}/>
              </svg>
              <span style={this.state.activetab === 'fd' ? {color: "#283A97", marginTop: "10px", fontSize: "9px"} : {color: "#898A8D", marginTop: "10px", fontSize: "9px"}}><br/>FD</span>
            </div>
          </Col> */}
          <Col className="text-center d-flex align-items-center justify-content-center col-3">
            <NavLink
              exact
              activeClassName="active"
              to="/biddeasy-dashboard"
              className="text-uppercase font-size-tiny font-weight-semi-bold"
              onClick={() => this.setActiveTab("bonds")}
              >
              <svg className="mb-2" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M0.907964 14.4258C1.10674 14.085 1.54411 13.9699 1.88486 14.1687L10.0964 18.9588L18.3079 14.1687C18.6487 13.9699 19.0861 14.085 19.2848 14.4258C19.4836 14.7665 19.3685 15.2039 19.0278 15.4027L10.4563 20.4027C10.2339 20.5324 9.9589 20.5324 9.7365 20.4027L1.16504 15.4027C0.82429 15.2039 0.709192 14.7665 0.907964 14.4258Z" fill={this.state.activetab === "bonds" ? "#283A97" : "#898A8D"}/>
                <path fillRule="evenodd" clipRule="evenodd" d="M0.907964 10.1401C1.10674 9.79939 1.54411 9.68429 1.88486 9.88306L10.0964 14.6731L18.3079 9.88306C18.6487 9.68429 19.0861 9.79939 19.2848 10.1401C19.4836 10.4809 19.3685 10.9183 19.0278 11.117L10.4563 16.117C10.2339 16.2468 9.9589 16.2468 9.7365 16.117L1.16504 11.117C0.82429 10.9183 0.709192 10.4809 0.907964 10.1401Z" fill={this.state.activetab === "bonds" ? "#283A97" : "#898A8D"}/>
                <path fillRule="evenodd" clipRule="evenodd" d="M9.73638 0.597301C9.95878 0.467566 10.2338 0.467566 10.4562 0.597301L19.0277 5.59732C19.2471 5.72532 19.382 5.96025 19.382 6.2143C19.382 6.46835 19.2471 6.70328 19.0277 6.83129L10.4562 11.8313C10.2338 11.961 9.95878 11.961 9.73638 11.8313L1.16493 6.83129C0.945484 6.70328 0.810547 6.46835 0.810547 6.2143C0.810547 5.96025 0.945484 5.72532 1.16493 5.59732L9.73638 0.597301ZM2.94244 6.2143L10.0963 10.3874L17.2501 6.2143L10.0963 2.04122L2.94244 6.2143Z" fill={this.state.activetab === "bonds" ? "#283A97" : "#898A8D"}/>
            </svg>
              <span style={this.state.activetab === 'bonds' ? {color: "#283A97", marginTop: "10px"} : {color: "#898A8D", marginTop: "10px"}}><br/>Bonds</span>
            </NavLink>
          </Col>
          <Col className="text-center d-flex align-items-center justify-content-center col-3">
            <div onClick={() => this.props.handlePortfolioClick()}>
                <svg className="mb-2" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M10.5954 0.5C11.0202 0.5 11.3646 0.844396 11.3646 1.26923V10.5C11.3646 10.9248 11.0202 11.2692 10.5954 11.2692C10.1706 11.2692 9.82617 10.9248 9.82617 10.5V1.26923C9.82617 0.844396 10.1706 0.5 10.5954 0.5Z" fill={this.state.activetab === "portfolio" ? "#283A97" : "#898A8D"}/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M19.2522 5.49984C19.4647 5.86772 19.3387 6.3382 18.9708 6.55069L2.99005 15.7815C2.62217 15.994 2.15169 15.868 1.9392 15.5001C1.72671 15.1322 1.85267 14.6618 2.22055 14.4493L18.2013 5.2185C18.5692 5.00601 19.0397 5.13197 19.2522 5.49984Z" fill={this.state.activetab === "portfolio" ? "#283A97" : "#898A8D"}/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M7.96322 1.17013C8.16698 1.31433 8.28811 1.54843 8.28811 1.79804V8.72112C8.28811 8.9957 8.14175 9.24946 7.90408 9.38696L1.90408 12.8581C1.68807 12.9831 1.42487 12.9955 1.19807 12.8914C0.971258 12.7873 0.809029 12.5797 0.7629 12.3345C0.649045 11.7292 0.593091 11.1144 0.595797 10.4984C0.594897 8.43085 1.23553 6.41389 2.42936 4.72573C3.62357 3.03703 5.31248 1.76061 7.263 1.07262C7.4984 0.989585 7.75946 1.02594 7.96322 1.17013ZM6.74964 2.96308C5.53336 3.5827 4.47999 4.49051 3.68546 5.61403C2.67514 7.04268 2.13315 8.74968 2.13426 10.4995L2.13425 10.5035C2.13358 10.6498 2.13684 10.796 2.14401 10.9419L6.74964 8.27746V2.96308Z" fill={this.state.activetab === "portfolio" ? "#283A97" : "#898A8D"}/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M9.8269 1.26914C9.82694 0.844309 10.1714 0.499952 10.5962 0.5C12.3485 0.500198 14.0699 0.96082 15.5881 1.83572C17.1063 2.71063 18.368 3.9691 19.2467 5.48509C20.1254 7.00107 20.5904 8.72134 20.595 10.4736C20.5997 12.2258 20.1438 13.9485 19.2731 15.4691C18.4024 16.9897 17.1474 18.2549 15.6338 19.1378C14.1203 20.0207 12.4013 20.4904 10.649 20.4999C8.89681 20.5093 7.17286 20.0582 5.64986 19.1917C4.12686 18.3251 2.85829 17.0736 1.97121 15.5625C1.75614 15.1961 1.87879 14.7248 2.24517 14.5097C2.61154 14.2946 3.08289 14.4173 3.29796 14.7837C4.04857 16.0623 5.12197 17.1213 6.41066 17.8545C7.69935 18.5877 9.15808 18.9694 10.6407 18.9614C12.1234 18.9534 13.5779 18.556 14.8586 17.8089C16.1393 17.0618 17.2012 15.9913 17.938 14.7047C18.6748 13.418 19.0605 11.9603 19.0566 10.4777C19.0527 8.99498 18.6592 7.53937 17.9157 6.25661C17.1721 4.97386 16.1046 3.90899 14.82 3.16869C13.5353 2.42839 12.0787 2.03863 10.596 2.03846C10.1712 2.03841 9.82685 1.69398 9.8269 1.26914Z" fill={this.state.activetab === "portfolio" ? "#283A97" : "#898A8D"}/>
                </svg>                    
              <p className="nav-link mb-0 cursor-pointer p-0" style={this.state.activetab === 'portfolio' ? {color: "#283A97", fontSize: "9px"} : {color: "#898A8D", fontSize: "9px"}}>PORTFOLIO</p>
            </div>
          </Col>
          {/* {this.props.isUserObInvested && 
            <Col className="text-center d-flex align-items-center justify-content-center col-3">
            <NavLink
                exact
                activeClassName="active"
                to="/portfolio"
                className="text-uppercase font-size-tiny font-weight-semi-bold"
                onClick={() => this.setActiveTab("portfolio")}
                >
                <svg className="mb-2" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M10.5954 0.5C11.0202 0.5 11.3646 0.844396 11.3646 1.26923V10.5C11.3646 10.9248 11.0202 11.2692 10.5954 11.2692C10.1706 11.2692 9.82617 10.9248 9.82617 10.5V1.26923C9.82617 0.844396 10.1706 0.5 10.5954 0.5Z" fill={this.state.activetab === "portfolio" ? "#283A97" : "#898A8D"}/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M19.2522 5.49984C19.4647 5.86772 19.3387 6.3382 18.9708 6.55069L2.99005 15.7815C2.62217 15.994 2.15169 15.868 1.9392 15.5001C1.72671 15.1322 1.85267 14.6618 2.22055 14.4493L18.2013 5.2185C18.5692 5.00601 19.0397 5.13197 19.2522 5.49984Z" fill={this.state.activetab === "portfolio" ? "#283A97" : "#898A8D"}/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M7.96322 1.17013C8.16698 1.31433 8.28811 1.54843 8.28811 1.79804V8.72112C8.28811 8.9957 8.14175 9.24946 7.90408 9.38696L1.90408 12.8581C1.68807 12.9831 1.42487 12.9955 1.19807 12.8914C0.971258 12.7873 0.809029 12.5797 0.7629 12.3345C0.649045 11.7292 0.593091 11.1144 0.595797 10.4984C0.594897 8.43085 1.23553 6.41389 2.42936 4.72573C3.62357 3.03703 5.31248 1.76061 7.263 1.07262C7.4984 0.989585 7.75946 1.02594 7.96322 1.17013ZM6.74964 2.96308C5.53336 3.5827 4.47999 4.49051 3.68546 5.61403C2.67514 7.04268 2.13315 8.74968 2.13426 10.4995L2.13425 10.5035C2.13358 10.6498 2.13684 10.796 2.14401 10.9419L6.74964 8.27746V2.96308Z" fill={this.state.activetab === "portfolio" ? "#283A97" : "#898A8D"}/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M9.8269 1.26914C9.82694 0.844309 10.1714 0.499952 10.5962 0.5C12.3485 0.500198 14.0699 0.96082 15.5881 1.83572C17.1063 2.71063 18.368 3.9691 19.2467 5.48509C20.1254 7.00107 20.5904 8.72134 20.595 10.4736C20.5997 12.2258 20.1438 13.9485 19.2731 15.4691C18.4024 16.9897 17.1474 18.2549 15.6338 19.1378C14.1203 20.0207 12.4013 20.4904 10.649 20.4999C8.89681 20.5093 7.17286 20.0582 5.64986 19.1917C4.12686 18.3251 2.85829 17.0736 1.97121 15.5625C1.75614 15.1961 1.87879 14.7248 2.24517 14.5097C2.61154 14.2946 3.08289 14.4173 3.29796 14.7837C4.04857 16.0623 5.12197 17.1213 6.41066 17.8545C7.69935 18.5877 9.15808 18.9694 10.6407 18.9614C12.1234 18.9534 13.5779 18.556 14.8586 17.8089C16.1393 17.0618 17.2012 15.9913 17.938 14.7047C18.6748 13.418 19.0605 11.9603 19.0566 10.4777C19.0527 8.99498 18.6592 7.53937 17.9157 6.25661C17.1721 4.97386 16.1046 3.90899 14.82 3.16869C13.5353 2.42839 12.0787 2.03863 10.596 2.03846C10.1712 2.03841 9.82685 1.69398 9.8269 1.26914Z" fill={this.state.activetab === "portfolio" ? "#283A97" : "#898A8D"}/>
                </svg>
                <span style={this.state.activetab === 'portfolio' ? {color: "#283A97", marginTop: "10px"} : {color: "#898A8D", marginTop: "10px"}}><br/>Portfolio</span>
              </NavLink>
            </Col>
          } */}
          {/* <Col className="text-center d-flex align-items-center justify-content-center col-3">
            <NavLink
              exact
              activeClassName="active"
              to="/biddeasy-dashboard"
              className="text-uppercase font-size-tiny font-weight-semi-bold"
              onClick={() => this.handleMoreClick("more")}
            >
              <svg className="mb-2" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M1.0957 0.5C0.543418 0.5 0.0957031 0.947715 0.0957031 1.5V8.5C0.0957031 9.05228 0.543418 9.5 1.0957 9.5H8.0957C8.64799 9.5 9.0957 9.05228 9.0957 8.5V1.5C9.0957 0.947715 8.64799 0.5 8.0957 0.5H1.0957ZM2.0957 7.5V2.5H7.0957V7.5H2.0957ZM12.0957 0.5C11.5434 0.5 11.0957 0.947715 11.0957 1.5V8.5C11.0957 9.05228 11.5434 9.5 12.0957 9.5H19.0957C19.648 9.5 20.0957 9.05228 20.0957 8.5V1.5C20.0957 0.947715 19.648 0.5 19.0957 0.5H12.0957ZM13.0957 7.5V2.5H18.0957V7.5H13.0957ZM14.0957 12.5C14.0957 11.9477 14.5434 11.5 15.0957 11.5H19.0957C19.648 11.5 20.0957 11.9477 20.0957 12.5V19.5C20.0957 20.0523 19.648 20.5 19.0957 20.5H12.0957C11.5434 20.5 11.0957 20.0523 11.0957 19.5V15.5C11.0957 14.9477 11.5434 14.5 12.0957 14.5C12.648 14.5 13.0957 14.9477 13.0957 15.5V18.5H18.0957V13.5H15.0957C14.5434 13.5 14.0957 13.0523 14.0957 12.5ZM1.0957 11.5C0.543418 11.5 0.0957031 11.9477 0.0957031 12.5V19.5C0.0957031 20.0523 0.543418 20.5 1.0957 20.5H8.0957C8.64799 20.5 9.0957 20.0523 9.0957 19.5V12.5C9.0957 11.9477 8.64799 11.5 8.0957 11.5H1.0957ZM2.0957 18.5V13.5H7.0957V18.5H2.0957Z" fill="#898A8D"/>
              </svg>
              <span style={{color: "#898A8D", marginTop: "10px"}}><br/>More</span>
            </NavLink>
          </Col> */}
          <Col className="text-center d-flex align-items-center justify-content-center col-3">
            <div
              className="text-uppercase font-size-tiny font-weight-semi-bold"
              onClick={() => this.props.handleReferClick()}
            >
              <span className="">
                <i className="mdi mdi-account-multiple-outline text-muted"></i>
              </span>
              <span style={this.state.activetab === 'refer' ? {color: "#283A97", fontSize: "10px", marginTop: "10px"} : {color: "#898A8D", fontSize: "10px", marginTop: "10px"}}><br/>Refer</span>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Header;
